module.exports = __webpack_public_path__ + "img/1.._14.6f589498.jpg";